import { SpeedMetrics, Theme } from "@shared/primitive-components"

export type SpeedingClassification = `summons` | `penalty` | `speeding` | `lawful` | `unreliable` | `unknown`

export const speedingClassification = (metrics: SpeedMetrics): SpeedingClassification => {
  const { speedMph, speedLimitMph, hasUnreliableSpeed } = metrics
  if (speedLimitMph === null) return `unknown`
  if (speedMph === null) return `lawful`
  if (hasUnreliableSpeed) return `unreliable`

  const thresholds = [
    { limit: 22, summons: 35, penalty: 24 },
    { limit: 32, summons: 50, penalty: 35 },
    { limit: 42, summons: 66, penalty: 46 },
    { limit: 52, summons: 76, penalty: 57 },
    { limit: 62, summons: 86, penalty: 68 },
    { limit: 72, summons: 96, penalty: 79 },
  ]

  const threshold = thresholds.find((t) => speedLimitMph <= t.limit)
  if (threshold) {
    if (speedMph > threshold.summons) return `summons`
    if (speedMph > threshold.penalty) return `penalty`
  }

  if (speedMph > speedLimitMph) return `speeding`
  return `lawful`
}

export const getColorForSpeedingClassification = (speedingClass: SpeedingClassification, theme: Theme) => {
  switch (speedingClass) {
    case `summons`:
      return theme.palette.full.red
    case `penalty`:
      return theme.palette.full.orange
    case `speeding`:
      return theme.palette.full.amber
    case `lawful`:
      return theme.palette.full.green
    case `unreliable`:
      return theme.palette.grey.dark
    default:
      return theme.palette.coal.dark
  }
}
